import { SyncOutlined } from '@ant-design/icons';
import { useTranslate } from '@tolgee/react';
import { useMount, useRequest } from 'ahooks';
import { message, Tooltip } from 'antd';
import dayjs from 'dayjs';
import { useCallback, useMemo, useState } from 'react';
import { syncItem, getSyncItemStatus } from 'services/api/conversation';

interface Props {
  internalStoreId: string;
  onSuccess?: () => void;
}

const SyncItem = (props: Props) => {
  const { internalStoreId, onSuccess } = props;
  const { t } = useTranslate();
  const [syncStatus, setSyncStatus] = useState({ lastSyncTimeMs: '', isSyncing: false });
  const [loading, setLoading] = useState(false);
  const getSyncStatus = useCallback(() => {
    const timer = setInterval(() => {
      getSyncItemStatus({ internalStoreId })
        .then((data) => {
          setSyncStatus(data);
          if (!data.isSyncing) {
            setLoading(false);
            message.success(t('商品数据更新成功'));
            clearInterval(timer);
            onSuccess?.();
            return;
          }
        })
        .catch(() => {
          clearInterval(timer);
        });
    }, 5 * 1000);
  }, [internalStoreId, t, onSuccess]);
  const { run: sync } = useRequest(
    async () => {
      try {
        setLoading(true);
        setSyncStatus({ lastSyncTimeMs: '', isSyncing: true });
        await syncItem({ internalStoreId });
        getSyncStatus();
      } catch (error) {
        message.error(t('更新失败，请稍后重试'));
      }
    },
    { manual: true },
  );
  useMount(() => {
    getSyncItemStatus({ internalStoreId }).then((data) => {
      setSyncStatus(data);
    });
  });
  const tooltip = useMemo(() => {
    if (loading) {
      return t('商品更新中');
    }
    return `${t('最后更新时间')}:${dayjs(Number(syncStatus?.lastSyncTimeMs)).format(
      'YYYY-MM-DD HH:mm:ss',
    )}`;
  }, [loading, syncStatus?.lastSyncTimeMs, t]);

  return (
    <Tooltip
      title={<div className="whitespace-nowrap">{tooltip}</div>}
      visible={syncStatus?.lastSyncTimeMs !== '0' || loading ? undefined : false}
    >
      <SyncOutlined className="cursor-pointer" onClick={sync} spin={loading} disabled={loading} />
    </Tooltip>
  );
};

export default SyncItem;
